<!-- TEMPLATE: AppBar.vue -->

<script setup lang="ts">
//
// Imports
//
import DrawerToggle from "../molecules/DrawerToggle.vue";
import PageTitle from "../molecules/PageTitle.vue";
import AppBarActions from "../organisms/AppBarActions.vue";
import AppBarExtensions from "../organisms/AppBarExtensions.vue";

//
// Props
//
withDefaults(
  defineProps<{
    color?: string;
    variant?: "flat" | "tonal" | "outlined" | "text" | "elevated";
    showPageTitle?: boolean;
  }>(),
  {
    color: "primary",
    variant: "flat",
    showPageTitle: true,
  },
);

//
// Composables
//

// Drawer
const { drawer } = useDrawer();

// Page Title
const { pageTitle, extensionsConfig } = useAppBar();
</script>

<template>
  <!-- NavBar -->
  <v-app-bar app :variant="variant" style="border-bottom: 1px solid #dfdfdf !important">
    <!-- Prepended Content -->
    <template #prepend>
      <!-- Drawer Toggle -->
      <drawer-toggle v-model="drawer" />

      <!-- Page Title -->
      <page-title v-if="showPageTitle" :title="pageTitle" />
    </template>

    <!-- Appended Content -->
    <template #append>
      <!-- Actions -->
      <app-bar-actions />
    </template>

    <!-- Extensions - Only render slot when needed -->
    <template v-if="extensionsConfig.show" #extension>
      <app-bar-extensions />
    </template>
  </v-app-bar>
</template>

<style>
/* App Bar */
.v-toolbar__content,
.v-toolbar__extension {
  align-items: end !important;
}
</style>
